<template>
  <TresGroup>
    <Plane :args="[3.2, 3.2]" :rotation="[0, 0, 0]" :position="[0, 0, 0]">
      <TresMeshStandardMaterial
        color="white"
        :map="logoTexture.map"
        :transparent="true"
        :opacity="0.9"
        :metalness="1"
        :roughness="0.1"
        :position="[3, 2, 0]"
      />
      <primitive
        ref="boxRef"
        :object="scene"
        :scale="[1.5, 1, 1.5]"
        :rotation="[Math.PI / 2, 0, 0]"
        :position="[0, 0, -0.34]"
      >
      </primitive>
    </Plane>
  </TresGroup>
</template>

<script setup lang="ts">
import { useTexture } from '@tresjs/core'
import { FrontSide, MeshStandardMaterial } from 'three'

interface Props {
  id?: number
  title?: string
  url?: string
  logo?: string
  scene: Scene
}

const props = withDefaults(defineProps<Props>(), {
  id: 0,
  title: 'Title',
  url: 'https://www.apple.com',
  logo: 'https://www.datocms-assets.com/142360/1731101051-frame-1.png',
  scene: null
})

const logoTexture = await useTexture({
  map: props.logo
})

const glassMaterial = new MeshStandardMaterial({
  metalness: 0.6,
  roughness: 0.4,
  color: 0x111111,
  envMapIntensity: 0.2,
  opacity: 1,
  side: FrontSide
})

const scene = props.scene.clone()

scene.traverse((child) => {
  if (child.isMesh) {
    if (child.name === 'Screen') {
      child.material.dispose()
      child.material = glassMaterial
    }
  }
})

/*
function onPointerEnter(ev: PointerEvent) {
  if (ev) {
    // console.log('onPointerEnter', ev)
    ev.object.material.color.set('#2A142F')
  }
}

function onPointerLeave(ev: PointerEvent) {
  if (ev) {
    // ev.object.material.color.set('#ffffff')
  }
}
*/

onUnmounted(() => {
  glassMaterial.dispose()
})
</script>
